document.addEventListener('DOMContentLoaded', initSlickAttribution);

function initSlickAttribution() {
  const elements = document.querySelectorAll('.slick-attribution');

  if (!elements.length) return;

  elements.forEach((element) => {
    let current = 0;
    const children = element.querySelectorAll('.slick-attribution-content');
    const length = children.length;

    if (!length) return;

    element.dataset.showing = current;
    children[0].setAttribute('aria-hidden', 'false');
    children.forEach((child, index) => {
      if (index !== 0) {
        child.setAttribute('aria-hidden', 'true');
      }
    });

    const intervalId = setInterval(() => {
      try {
        rotateAttributionElement();
      } catch (error) {
        console.error('Error rotating attribution:', error);
        clearInterval(intervalId);
      }
    }, 5000);

    function rotateAttributionElement() {
      current = (current + 1) % length;
      element.dataset.showing = current;

      children.forEach((child, index) => {
        child.setAttribute('aria-hidden', current !== index);
      });
    }
  });
}
